import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { AppRoutingModule } from '../app-routing.module';
import { MatMenuModule } from '@angular/material/menu';
import { ComponentsModule } from "../components/components.module";
import { MatButtonModule } from '@angular/material/button';
import { NormaluserLayoutComponent } from './layouts/normaluser-layout/normaluser-layout.component';
import { ServicemanagerLayoutComponent } from './layouts/servicemanager-layout/servicemanager-layout.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BusinessuserLayoutComponent } from './layouts/businessuser-layout/businessuser-layout.component';
import { AdminuserLayoutComponent } from './layouts/adminuser-layout/adminuser-layout.component';
import { SharedModule } from '../shared/shared.module';
import { PlainLayoutComponent } from './layouts/plain-layout.component';
import { RouterModule } from '@angular/router';

// translate 
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    ServicemanagerLayoutComponent,
    NormaluserLayoutComponent,
    BusinessuserLayoutComponent,
    AdminuserLayoutComponent,
    PlainLayoutComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    MatIconModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatExpansionModule,
    AppRoutingModule,
    MatMenuModule,
    ComponentsModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    // translate 
    HttpClientModule,
    TranslateModule,
  ],
  providers: [HttpClient]
})
export class CoreModule { }
